import * as React from 'react';
import { useEffect, useState } from 'react';

import { useStores } from 'hooks';

import { getLogoUrl, useBannersContext } from 'features/banners';

function Logo(): JSX.Element {
  const {
    app: { program },
  } = useStores();
  const { layoutId, logoId } = useBannersContext();

  const [url, setUrl] = useState('');

  useEffect(() => {
    const nextUrl = getLogoUrl({ logoId, layoutId });
    setUrl(nextUrl);
  }, [layoutId, logoId]);

  return (
    <picture className="logo">
      <img src={url} alt={program?.name} />
    </picture>
  );
}

export { Logo };
